import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useMemo } from 'react'
import { WalletConnectorName } from '../types'
import { useWalletConnectors } from './useWalletConnectors'

export const useConnectedWalletName = () => {
  const { connector } = useWeb3()
  const connectors = useWalletConnectors()

  return useMemo(() => {
    const [connectorName] =
      Object.entries(connectors).find(
        ([, connectorObj]) => connectorObj === connector,
      ) ?? []

    return connectorName as WalletConnectorName | undefined
  }, [connector, connectors])
}
